import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center w-full photos-container mb-2" }
const _hoisted_2 = { class: "w-full cursor-pointer" }
const _hoisted_3 = { class: "flex items-center justify-center w-full p-6 pb-5 gap-2" }
const _hoisted_4 = {
  key: 0,
  class: "photo-loader-icon"
}
const _hoisted_5 = {
  key: 1,
  class: "photo-loader-indicator"
}
const _hoisted_6 = {
  key: 2,
  class: "text-gray-500"
}
const _hoisted_7 = {
  key: 3,
  class: "text-gray-500"
}
const _hoisted_8 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_9 = { class: "w-full mt-3" }
const _hoisted_10 = {
  key: 0,
  class: "rounded-md bg-red-50 p-4"
}
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = { class: "shrink-0" }
const _hoisted_13 = { class: "ml-3 w-full" }
const _hoisted_14 = { class: "flex justify-between w-full items-start" }
const _hoisted_15 = { class: "text-sm font-medium text-red-800" }
const _hoisted_16 = { class: "mt-2 text-sm text-red-700" }
const _hoisted_17 = {
  role: "list",
  class: "space-y-1.5"
}
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowUpTrayIcon = _resolveComponent("ArrowUpTrayIcon")!
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")!
  const _component_ArrowPathIcon = _resolveComponent("ArrowPathIcon")!
  const _component_PhotoProcessingManager = _resolveComponent("PhotoProcessingManager")!
  const _component_UploadLimitModalAlertComponent = _resolveComponent("UploadLimitModalAlertComponent")!
  const _component_DuplicateFilesModalComponent = _resolveComponent("DuplicateFilesModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          type: "file",
          id: "files-input",
          class: "hidden",
          name: "images",
          multiple: "",
          accept: "image/*, video/*, .cr2, .raf, .cr3, .arw, .nef, .nrw, .dng",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectFiles && _ctx.selectFiles(...args))),
          ref: "photos-uploader-input"
        }, null, 544),
        _createElementVNode("div", {
          class: _normalizeClass({
                    'bg-white/70 rounded-md border-1 border-dashed border-gray-300 w-full flex flex-col items-center justify-center hover:border-gray-400 hover:bg-white transition duration-200': true,
                    'border-solid': _ctx.totalFiles > 0,
                    'drag': _ctx.isDragging
                }),
          id: "photo-loader",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clickSelectFiles && _ctx.clickSelectFiles(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.totalFiles === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_ArrowUpTrayIcon, { class: "size-8 text-gray-500" })
                ]))
              : _createCommentVNode("", true),
            (_ctx.totalFiles > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[5] || (_cache[5] = [
                  _createStaticVNode("<svg version=\"1.1\" id=\"L6\" class=\"size-8\" width=\"100%\" height=\"100%\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\" data-v-14e48623><rect fill=\"#f59c25\" stroke=\"#f1f3f9\" stroke-width=\"4\" x=\"25\" y=\"25\" width=\"50\" height=\"50\" data-v-14e48623><animateTransform attributeName=\"transform\" dur=\"0.5s\" from=\"0 50 50\" to=\"180 50 50\" type=\"rotate\" id=\"strokeBox\" attributeType=\"XML\" begin=\"rectBox.end\" data-v-14e48623></animateTransform></rect><rect x=\"27\" y=\"27\" fill=\"#f1f3f9\" width=\"46\" height=\"50\" data-v-14e48623><animate attributeName=\"height\" dur=\"1.3s\" attributeType=\"XML\" from=\"50\" to=\"0\" id=\"rectBox\" fill=\"freeze\" begin=\"0s;strokeBox.end\" data-v-14e48623></animate></rect></svg>", 1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.totalFiles > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.$t('photo_uploader.uploading_files')) + " ", 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.uploadedFileIds.length) + " " + _toDisplayString(_ctx.$t('photo_uploader.of')) + " " + _toDisplayString(_ctx.totalFiles) + " (" + _toDisplayString(_ctx.uploadedSizeString) + " / " + _toDisplayString(_ctx.totalSizeString) + ")", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.totalFiles === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('photo_uploader.upload_files')), 1))
              : _createCommentVNode("", true),
            (_ctx.shouldShowMemoryInfo && _ctx.memoryInfo !== 'N/A')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: _normalizeClass(["text-xs text-gray-400 mt-1", {'text-red-500': _ctx.isMemoryWarning}])
                }, [
                  _createTextVNode(" 🧠 " + _toDisplayString(_ctx.memoryInfo) + " ", 1),
                  (_ctx.isMemoryWarning)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "⚠️"))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass({'w-full bg-gray-200 h-1.5 rounded': true, 'opacity-0': _ctx.totalFiles === 0})
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([{
                          'bg-yellow-500': true
                        }, "h-full rounded-md"]),
              style: _normalizeStyle({ width: `${_ctx.uploadingProgress}%` })
            }, null, 4)
          ], 2)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.errors.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_XCircleIcon, {
                    class: "size-5 text-red-400",
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t('photo_uploader.upload_errors')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("ul", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: `loading-error-${index}`,
                          class: "flex items-center gap-1.5"
                        }, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.retryFileById(error.fileId)), ["prevent"]),
                            class: "bg-red-100 text-red-700 rounded-md px-1.5 py-1 text-sm cursor-pointer hover:bg-white/70"
                          }, [
                            _createVNode(_component_ArrowPathIcon, { class: "size-4" })
                          ], 8, _hoisted_18),
                          _createElementVNode("span", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.getFileNameById(error.fileId)), 1),
                            _createTextVNode(": " + _toDisplayString(error.message), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_PhotoProcessingManager, {
        "photo-ids": _ctx.uploadedPhotoIds,
        enabled: _ctx.uploadedPhotoIds.length > 0,
        onProcessingComplete: _ctx.onProcessingComplete
      }, null, 8, ["photo-ids", "enabled", "onProcessingComplete"])
    ]),
    _createVNode(_component_UploadLimitModalAlertComponent, {
      open: _ctx.showUploadLimitModal,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showUploadLimitModal = false)),
      type: _ctx.limitUploadModalType
    }, null, 8, ["open", "type"]),
    _createVNode(_component_DuplicateFilesModalComponent, {
      open: _ctx.showDuplicatesModal,
      filesNames: _ctx.duplicateFileNames,
      onClose: () => {},
      onSkip: _cache[3] || (_cache[3] = ($event: any) => (_ctx.proceedWithPendingUpload(true))),
      onUploadBoth: _cache[4] || (_cache[4] = ($event: any) => (_ctx.proceedWithPendingUpload(false))),
      title: String(_ctx.$t('photo_uploader.duplicates_title')) || 'Знайдено файли з однаковою назвою',
      message: String(_ctx.$t('photo_uploader.duplicates_message')) || 'Деякі обрані файли вже існують у галереї. Оберіть дію:',
      skipText: String(_ctx.$t('photo_uploader.skip')) || 'Пропустити',
      uploadBothText: String(_ctx.$t('photo_uploader.upload_both')) || 'Завантажити обидва'
    }, null, 8, ["open", "filesNames", "title", "message", "skipText", "uploadBothText"])
  ], 64))
}